import { createAction } from 'redux-actions';

export const clearOutreaches = createAction('CLEAR_OUTREACHES');

export const outreachesOnChangePage = createAction('OUTREACHES_ON_CHANGE_PAGE');

export const outreachesOnChangeOrder = createAction(
  'OUTREACHES_ON_CHANGE_ORDER'
);
